import React, {FC} from 'react';

import {Colors, DndUploadBox, Title} from '@optimaxdev/design-system';
import {ValidFileType} from '@optimaxdev/design-system/dist/types/lib/uploader/uploader';
import {Approve, Icon} from '@optimaxdev/icons';

import {JPG, PNG, GIF, PDF, MAX_FILE_SIZE} from 'constants/file/fileTypes';

import {FileSpeciesType} from 'types/successPage';

import s from './uploadPrescriptionForm.scss';

export type PropsType = {
    onClick?: () => void;
    onUpload: (file: string, name: string, fileType: FileSpeciesType) => void;
    uploadedFile: string;
};

const FILE_TYPES: ValidFileType[] = [JPG, PNG, GIF, PDF];
/**
 * Component for uploading prescription file
 */
export const UploadPrescriptionForm: FC<PropsType> = ({onClick, onUpload, uploadedFile}) => {
    const isDesktop = __BUILD_TYPE__ === 'desktop';

    const renderInitialText = () => {
        if (isDesktop) {
            return (
                <>
                    You can easily upload your prescription file in any of the following formats:
                    PDF, JPG, GIF, PNG, JPEG.
                </>
            );
        }

        return (
            <>You can upload a scan of your prescription or take a photo with your mobile phone.</>
        );
    };

    return (
        <div>
            {uploadedFile ? (
                <>
                    <Title
                        className={s.title}
                        color={Colors.limedSpruce}
                        fontSize="16px"
                        level={3}
                        margin="0 0 8px 0"
                    >
                        <span className={s.approveIconWrapper}>
                            <Icon icon={Approve} strokeWidth={2} width={8} />
                        </span>
                        Prescription uploaded
                    </Title>
                    <p className={s.text}>
                        Please confirm the prescription file and we&apos;ll start processing your
                        order immediately.
                    </p>
                </>
            ) : (
                <p className={s.text}>{renderInitialText()}</p>
            )}
            <form className={s.form}>
                <DndUploadBox
                    onUpload={(file, fileName, fileType) =>
                        onUpload(file, fileName, fileType as FileSpeciesType)
                    }
                    fileTypes={FILE_TYPES}
                    maxSize={MAX_FILE_SIZE}
                    onClick={onClick}
                    uploadedImage={uploadedFile}
                />
            </form>
        </div>
    );
};
